import React from "react";
import DOMPurify from "dompurify";

class ApiPreguntas extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      pregunta_campo: '',
      respuesta: {},
    };
  }

  limpiarPregunta(texto) {

    texto = texto.replace(/[^\w\s]/gi, '');

    texto = texto.replace(/[á]/gi, 'a');
    texto = texto.replace(/[é]/gi, 'e');
    texto = texto.replace(/[í]/gi, 'i');
    texto = texto.replace(/[ó]/gi, 'o');
    texto = texto.replace(/[ú]/gi, 'u');


    texto = texto.toLowerCase();

    return texto;
  }


  componentDidMount() {
    const { steps } = this.props;
    const { pregunta_campo } = steps;
  
    const startTime = performance.now();
    let pregunta = this.limpiarPregunta( pregunta_campo.value );
  
    const platformId = 3;
  
    let userId = localStorage.getItem( "chatUserId" );
    if ( !userId ) {
      userId = crypto.randomUUID();
      localStorage.setItem( "chatUserId", userId );
    }
  
    const fetchDBInfo = async () => {
      try {
        const dbResponse = await fetch( `https://laravel-helpdesk.uaem.mx/api/get-preguntas?platform_id=${platformId}&user_id=${userId}` );
        const dbData = await dbResponse.json();
  
        const response = await fetch( "https://laravel-helpdesk.uaem.mx/api/chatbot/preguntar", {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json',
            'Accept': 'application/json'
          },
          body: JSON.stringify( {
            pregunta: pregunta,
            contexto: dbData.contexto,
            historial: dbData.historial
          } )
        } );
  
        const data = await response.json();
        const endTime = performance.now();
        const responseTimeInSeconds = ( endTime - startTime ) / 1000;
  
        let openAiRespuesta = "Por el momento no estoy disponible. Intenta más tarde";
  
        if ( data.ok && data.respuesta ) {
          openAiRespuesta = data.respuesta;
        }
  
        this.setState( { respuesta: { respuesta: openAiRespuesta } } );
  
        const params = {
          userId: userId,
          respuestaIA: openAiRespuesta,
          preguntaOriginal: pregunta_campo.value,
          tiempoRespuesta: responseTimeInSeconds
        };
  
        const serializeParams = ( params ) =>
          Object.keys( params )
            .map( key => encodeURIComponent( key ) + '=' + encodeURIComponent( params[key] ) )
            .join( '&' );
  
        await fetch( "https://laravel-helpdesk.uaem.mx/api/store-pregunta", {
          method: 'POST',
          headers: {
            'Accept': 'application/json',
            'Content-Type': 'application/x-www-form-urlencoded'
          },
          body: serializeParams( params )
        } );
  
      } catch ( error ) {
        this.setState( { respuesta: { respuesta: "Intenta más tarde" } } );
        console.error( error );
      }
    };
  
    fetchDBInfo();
  }

  componentDidUpdate(prevProps, prevState) {
    if (
      this.state.respuesta &&
      this.state.respuesta !== prevState.respuesta
    ) {
      // Esperamos 200ms por si el render necesita completarse
      setTimeout(() => {
        this.props.triggerNextStep();
      }, 500);
    }
  }
  
  

  render() {
    const { respuesta } = this.state;

    return (
      <div
        dangerouslySetInnerHTML={ {
          __html: DOMPurify.sanitize( respuesta.respuesta || '' )
        } }
      />
    );
  }
}

export default ApiPreguntas;

